import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  data: [],
  meta: {},
  loaded: false,
  loading: false,
  error: null,
};

const locations = createSlice({
  name: 'locations',
  initialState,
  reducers: {
    getLocationsRequest: (state) => {
      state.loading = true;
      state.loaded = false;
      state.payout = null;
    },
    getLocationsSuccess: (state, { payload }) => {
      state.data = payload.data;
      state.meta = payload.meta;
      state.loading = false;
      state.loaded = true;
    },
    getLocationsFailure: (state, { payload }) => {
      state.loading = false;
      state.loaded = true;
      state.error = payload.error;
    },
    deleteLocationRequest: (state) => {
      state.loading = true;
      state.payout = null;
    },
    deleteLocationSuccess: (state, { payload }) => {
      state.data = state.data.filter(({ id }) => (id !== payload.id));
      state.loading = false;
    },
    deleteLocationFailure: (state, { payload }) => {
      state.loading = false;
      state.error = payload.error;
    },
    editLocationRequest: (state) => {
      state.loading = true;
      state.payout = null;
    },
    editLocationSuccess: (state, { payload }) => {
      const i = state.data.findIndex(({ id }) => id === payload.data.id);
      if (i < 0) state.data.push(payload.data);
      else state.data[i] = payload.data;
      state.loading = false;
    },
    editLocationFailure: (state, { payload }) => {
      state.loading = false;
      state.error = payload.error;
    },
  },
});

export const { actions } = locations;
export default locations.reducer
